import { Component, HostListener } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { NavigationService } from './shared/service/navigation.service';
import { Router, NavigationEnd, Event } from '@angular/router';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: []
})
export class AppComponent {
  update: boolean = false
  disableLoader: boolean = environment.DisableLoader;
  constructor(
    private navigationService: NavigationService, updates: SwUpdate, private router: Router
  ) {
    updates.available.subscribe(event => {
      location.reload(true);
    });

    router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        let scrollToTop = window.setInterval(() => {
          let pos = window.pageYOffset;
          if (pos > 0) {
            window.scrollTo(1000, pos - 1000); // how far to scroll on each step
          } else {
            window.clearInterval(scrollToTop);
          }
        }, 16);
      }

    });
  }

  getDepth(outlet) {
    return outlet.activatedRouteData['depth'];

  }

  getRouteAnimation(outlet) {
    return this.navigationService.animationValue;
  }

  @HostListener('window:popstate', ['$event'])
  onPopState() {
    this.navigationService.backPerviousPage(false);
  }
}


